import React, { useState, useEffect } from "react";
import {
  Box,
  createTheme,
  Stack,
  Typography,
  Grid,
  Radio,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import axios from "axios";
import { useParams } from "react-router-dom";
import RevenueAndIncomeOperatingChart from "./Charts/RevenueAndIncomeOperatingChart";
import NetIncomeChart from "./Charts/NetIncomeChart";
import GrowthChart from "./Charts/GrowthChart";
import OperatingExpensesChart from "./Charts/OperatingExpensesChart";
import { makeStyles } from "@mui/styles";
import DebtAndCashChart from "./Charts/DebtAndCashChart";
import MarginsChart from "./Charts/MarginsChart";
import CashFlowChart from "./Charts/CashFlowChart";
import OutstandingSharesChart from "./Charts/OutstandingSharesChart";
import EarningsPerShareChart from "./Charts/EarningsPerShareChart";
import PToEChart from "./Charts/PToEChart";
import MarketCapChart from "./Charts/MarketCapChart";
import OPEXCharts from "./Charts/OPEXCharts";
import RevenueMultipleChart from "./Charts/RevenueMultipleChart";

const useStyles = makeStyles({
  revenueBar: {
    display: "flex",
    gap: "30px",
    justifyContent: "center",
    padding: "10px 20px",
    width: "max-content",
    borderRafius: "8px",
  },
  revenueSpan: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  rh3: {
    fontFamily: "public sans",
    fontSize: "1rem",
    fontWeight: "300",
  },
  rh6: {
    fontFamily: "public sans",
    fontSize: "0.75rem",
    fontWeight: "600",
  },
});

const FinancialsContainer = ({
  stockData,
  stockStat,
  advanceStockStat,
  mode,
  token,
  setOpenComparison,
}) => {
  const [financialPeriod, setFP] = useState("annual");
  const [incomeDetails, setIncomeDetails] = useState({});
  const [cashFlows, setCashFlows] = useState({});
  const [reportedFinancials, setReportedFinancials] = useState({});
  const [balanceSheets, setBalanceSheets] = useState({});
  /** financials using for cash,net cash debt etc */
  const [financials, setFinancials] = useState({});
  const [yearOverYearRevenue, setYYRevenue] = useState(0);
  const [mostRecentQuarter, setMRQ] = useState("FY");
  const [isLoading, setIsLoading] = useState(true);

  const params = useParams();
  useEffect(() => {
    // console.log("stock data", stockData);
    // console.log("stock stat", stockStat);
    // // console.log("incomeDetails", incomeDetails);
    // console.log("advanceStockStat", advanceStockStat);
    // console.log(params?.symbol);
  }, [stockData, stockStat, advanceStockStat]);
  useEffect(() => {
    // console.log("financials", financials);
    if (financials?.quarterly?.financials) {
      let temp = financials?.quarterly?.financials;
      let y1 = temp[0];
      let y2Arr = temp.filter((t) => {
        if (
          t?.fiscalQuarter == y1?.fiscalQuarter &&
          t?.fiscalYear == y1?.fiscalYear - 1
        ) {
          return true;
        }
      });
      let y2 = y2Arr[0];
      let x = (y1?.totalRevenue / y2?.totalRevenue - 1) * 100;
      // console.log("yesr over year revenue gowth", x, y1, y2);
      setYYRevenue(x);
    }
    if (incomeDetails?.quarterly?.income) {
      let temp = incomeDetails?.quarterly?.income;
      setMRQ(`FY${temp[0]?.fiscalYear - 2000} Q${temp[0]?.fiscalQuarter}`);
    }
  }, [financials, incomeDetails]);
  useEffect(() => {
    try {
      /************** */
      axios
        .get(
          ` https://cloud.iexapis.com/stable/stock/${params?.symbol}/income?period=annual&&last=16&&token=${token}`
        )
        .then((annualRes) => {
          axios
            .get(
              ` https://cloud.iexapis.com/stable/stock/${params?.symbol}/income?period=quarterly&&last=16&&token=${token}`
            )
            .then((quarterlyRes) => {
              setIncomeDetails({
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
              console.log("incomeeeeeeeeeeeeeeee", {
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
              setTimeout(() => {
                setIsLoading(false);
              }, 500);
            });
        });
      /*************** */
      axios
        .get(
          ` https://cloud.iexapis.com/stable/stock/${params?.symbol}/financials?period=annual&&last=16&&token=${token}`
        )
        .then((annualRes) => {
          axios
            .get(
              ` https://cloud.iexapis.com/stable/stock/${params?.symbol}/financials?period=quarterly&&last=16&&token=${token}`
            )
            .then((quarterlyRes) => {
              setFinancials({
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
              console.log("financials", {
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
            });
        });

      axios
        .get(
          `https://cloud.iexapis.com/stable/stock/${params?.symbol}/cash-flow?period=annual&&token=${token}&&last=16`
        )
        .then((annualRes) => {
          axios
            .get(
              `https://cloud.iexapis.com/stable/stock/${params?.symbol}/cash-flow?period=quarterly&&token=${token}&&last=16`
            )
            .then((quarterlyRes) => {
              setCashFlows({
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
              console.log("cash flow", {
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
            });
        });

      axios
        .get(
          `https://cloud.iexapis.com/stable/stock/${params?.symbol}/balance-sheet?period=anual&&token=${token}`
        )
        .then((annualRes) => {
          axios
            .get(
              `https://cloud.iexapis.com/stable/stock/${params?.symbol}/balance-sheet?period=quarterly&&token=${token}`
            )
            .then((quarterlyRes) => {
              console.log("balance sheet", {
                annual: annualRes,
                quarterly: quarterlyRes,
              });
              setBalanceSheets({
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
            });
        });
      /****reportedFinancials */
      axios
        .get(
          `https://cloud.iexapis.com/stable/time-series/REPORTED_FINANCIALS/${params?.symbol}/10-K?token=${token}&&last=16`
        )
        .then((annualRes) => {
          axios
            .get(
              `https://cloud.iexapis.com/stable/time-series/REPORTED_FINANCIALS/${params?.symbol}/10-Q?token=${token}&&last=16`
            )
            .then((quarterlyRes) => {
              setReportedFinancials({
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
              console.log("reported financials", {
                annual: annualRes.data,
                quarterly: quarterlyRes.data,
              });
            });
        });
    } catch (err) {
      console.log(err);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, []);
  // console.log("financialPeriod in home", financialPeriod);
  /************** */
  const classes = useStyles();
  const handleFPChange = (event) => {
    setFP(event.target.value);
  };
  const controlProps = (item) => ({
    checked: financialPeriod === item,
    onChange: handleFPChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  return (
    <Box
      sx={{ backgroundColor: "bgPrimary.main" }}
      className="financial__container"
    >
      {isLoading ? (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <CircularProgress sx={{ color: "fontPrimaryColor.main" }} />
        </Box>
      ) : (
        <>
          {incomeDetails?.annual?.income ||
          financials?.annual?.financial ||
          reportedFinancials?.annual?.length > 0 ? (
            <Box className="main__content">
              <Box
                sx={{
                  backgroundColor: "bgSecondary.main",
                  // flexDirection: { xs: "column", md: "row" },
                  width: { xs: "90vw", sm: "55vw", lg: "45vw" },
                  flexWrap: "wrap",
                }}
                className={classes.revenueBar}
              >
                <Box className={classes.revenueSpan}>
                  <Box
                    sx={{ color: "fontPrimaryColor.main" }}
                    className={classes.rh6}
                  >
                    TTm Revenue
                  </Box>
                  <Box
                    sx={{ color: "fontPrimaryColor.main", textAlign: "center" }}
                    className={classes.rh3}
                  >
                    ${numFormatter(advanceStockStat.revenue)}
                  </Box>
                </Box>
                <Box className={classes.revenueSpan}>
                  <Box
                    sx={{ color: "fontPrimaryColor.main" }}
                    className={classes.rh6}
                  >
                    TTm Revenue Multiple
                  </Box>
                  <Box
                    sx={{ color: "fontPrimaryColor.main", textAlign: "center" }}
                    className={classes.rh3}
                  >
                    {advanceStockStat?.enterpriseValueToRevenue?.toFixed(1)}x
                  </Box>
                </Box>
                <Box className={classes.revenueSpan}>
                  <Box
                    sx={{ color: "fontPrimaryColor.main", textAlign: "center" }}
                    className={classes.rh6}
                  >
                    Revenue Growth Y/Y
                  </Box>
                  <Box
                    sx={{ color: "fontPrimaryColor.main", textAlign: "center" }}
                    className={classes.rh3}
                  >
                    {yearOverYearRevenue?.toFixed(2)}%
                  </Box>
                </Box>
                <Box className={classes.revenueSpan}>
                  <Box
                    sx={{ color: "fontPrimaryColor.main", textAlign: "center" }}
                    className={classes.rh6}
                  >
                    Most Recent Quarter
                  </Box>
                  <Box
                    sx={{ color: "fontPrimaryColor.main", textAlign: "center" }}
                    className={classes.rh3}
                  >
                    {mostRecentQuarter}
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: "30px" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <Radio
                    {...controlProps("quarterly")}
                    sx={{
                      color: "fontSecondaryColor.main",
                      "&.Mui-checked": {
                        color: "rRedColor.main",
                      },
                    }}
                  />
                  <Box
                    color="fontPrimaryColor.main"
                    sx={{
                      fontFamily: "public sans",
                      fontSize: "0.8rem",
                      fontWeight: "400",
                    }}
                  >
                    Quarterly
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <Radio
                    {...controlProps("annual")}
                    sx={{
                      color: "fontSecodaryColor.main",
                      "&.Mui-checked": {
                        color: "rRedColor.main",
                      },
                    }}
                  />
                  <Box
                    color="fontPrimaryColor.main"
                    sx={{
                      fontFamily: "public sans",
                      fontSize: "0.8rem",
                      fontWeight: "400",
                    }}
                  >
                    Annual
                  </Box>
                </Box>
              </Box>

              {incomeDetails?.annual?.income?.length > 0 &&
                incomeDetails?.quarterly?.income?.length > 0 && (
                  <Box className="chart__cover__box">
                    <RevenueAndIncomeOperatingChart
                      incomeDetails={incomeDetails}
                      financialPeriod={financialPeriod}
                      mode={mode}
                    />
                  </Box>
                )}

              {incomeDetails?.annual?.income?.length > 0 &&
                incomeDetails?.quarterly?.income?.length > 0 && (
                  <Box className="chart__cover__box">
                    <NetIncomeChart
                      incomeDetails={incomeDetails}
                      mode={mode}
                      financialPeriod={financialPeriod}
                      setOpenComparison={setOpenComparison}
                    />
                  </Box>
                )}

              {incomeDetails?.annual?.income?.length > 0 &&
                incomeDetails?.quarterly?.income?.length > 0 && (
                  <Box className="chart__cover__box">
                    <MarginsChart
                      incomeDetails={incomeDetails}
                      financialPeriod={financialPeriod}
                      mode={mode}
                    />
                  </Box>
                )}
              {incomeDetails?.annual?.income?.length > 0 &&
                incomeDetails?.quarterly?.income?.length > 0 && (
                  <Box className="chart__cover__box">
                    <OPEXCharts
                      incomeDetails={incomeDetails}
                      financialPeriod={financialPeriod}
                      mode={mode}
                    />
                  </Box>
                )}

              {financials?.annual?.financials?.length > 0 &&
                financials?.quarterly?.financials?.length > 0 && (
                  <Box className="chart__cover__box">
                    <DebtAndCashChart
                      financials={financials}
                      financialPeriod={financialPeriod}
                      mode={mode}
                    />
                  </Box>
                )}

              {incomeDetails?.annual?.income?.length > 0 &&
                incomeDetails?.quarterly?.income?.length > 0 && (
                  <Box className="chart__cover__box">
                    <GrowthChart
                      incomeDetails={incomeDetails}
                      financialPeriod={financialPeriod}
                      mode={mode}
                    />
                  </Box>
                )}

              {cashFlows?.annual?.cashflow?.length > 0 &&
                cashFlows?.quarterly?.cashflow?.length > 0 && (
                  <Box className="chart__cover__box">
                    <CashFlowChart
                      financialPeriod={financialPeriod}
                      cashFlowDetails={cashFlows}
                      mode={mode}
                    />
                  </Box>
                )}

              {reportedFinancials?.annual?.length > 0 &&
                reportedFinancials?.quarterly?.length > 0 && (
                  <>
                    <Box className="chart__cover__box">
                      <OutstandingSharesChart
                        // incomeDetails={incomeDetails}
                        financialPeriod={financialPeriod}
                        reportedFinancials={reportedFinancials}
                        mode={mode}
                      />
                    </Box>
                    <Box className="chart__cover__box">
                      <EarningsPerShareChart
                        incomeDetails={incomeDetails}
                        financialPeriod={financialPeriod}
                        reportedFinancials={reportedFinancials}
                        mode={mode}
                      />
                    </Box>
                    <Box className="chart__cover__box">
                      <MarketCapChart
                        token={token}
                        incomeDetails={incomeDetails}
                        financialPeriod={financialPeriod}
                        reportedFinancials={reportedFinancials}
                        symbol={params?.symbol}
                        mode={mode}
                      />
                    </Box>
                    <Box className="chart__cover__box">
                      <PToEChart
                        token={token}
                        incomeDetails={incomeDetails}
                        financialPeriod={financialPeriod}
                        reportedFinancials={reportedFinancials}
                        symbol={params?.symbol}
                        mode={mode}
                      />
                    </Box>
                  </>
                )}
              {financials?.annual?.financials?.length > 0 && (
                <Box className="chart__cover__box">
                  <RevenueMultipleChart
                    financials={financials}
                    token={token}
                    financialPeriod={financialPeriod}
                    reportedFinancials={reportedFinancials}
                    symbol={params?.symbol}
                    mode={mode}
                  />
                </Box>
              )}

              {/* <Box className="operatingExpensesWrapper">
   <OperatingExpensesChart
     incomeDetails={incomeDetails?.quarterly}
     mode={mode}
   />
 </Box> */}
            </Box>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  width: "max-content",
                  fontFamily: "public sans",
                  color: "fontPrimaryColor.main",
                }}
              >
                Financials not available.
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default FinancialsContainer;

function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900) {
    return num; // if value < 1000, nothing to do
  }
}
